import api from 'js/api'
export const updateUserProfile = data => {
  return api('PUT', 'userprofile/v2/me', data)
}
